import Axios from 'axios';
import { request as baseRequest, util } from '@tencent/ppd-base-libs';
import { CustomException } from '@/utils/error';
import { addLoginCount, isCodeUsed, isLoginCountOver, redirectLogin, resetLoginCount, setCodeUsed } from '@/business/login';
import { getParameterByName } from '@/utils';
import { showBusinessError } from '@/fit-components/dialog/main';
import { report } from '@tencent/ppd-report-sdk-web';
const baseUrl = 'https://weremit.tenpay.com/cgi-bin/';
// 未登录错误码列表
const unloginCodeArr = [1610700102, 1611113012, 1610700103];
const appid = 'wx7c6120c7a4c2ed5d';
baseRequest.init(Axios);


export interface BaseResp {
  retcode: number; // 返回码，0表示成功，其他失败
  resmsg: string; // 返回信息
  data: {
    mini_program_openid: string;
  }
}

async function accLogin(code: string): Promise<BaseResp> {
  return Axios.get('https://weremit.tenpay.com/cgi-bin/remitgc/we_remit_gc_official_acc_login.fcgi', {
    params: {
      // 微信服务器返回code
      code,
    },
  });
}

// 登录公众号
async function login() {
  const code = getParameterByName('code');
  console.log(`login:${code},${isCodeUsed(code as string)},${!code || isCodeUsed(code)}`);
  if (!code || isCodeUsed(code)) {
    // 如果没有code 或者已经使用过code 都要重定向
    console.log('login:redirectLogin');
    addLoginCount();
    redirectLogin(appid);
    // 避免执行后续逻辑
    return new Promise(() => {
      setTimeout(() => {
        console.log('5秒后未登录');
        // 已经登录的情况下 用户后退 却不会重新触发微信的跳转 这里加上兜底刷新逻辑
        location.reload();
      }, 5000);
    });
  }
  setCodeUsed(code);
  // 公众号登录
  const [err, res] = await util.to(accLogin(code));
  console.log(`login:accLogin:${code}`);
  if (err) {
    throw new CustomException(err, 'AccLoginFailed', '公众号登录失败');
  }
  const miniProgramOpenid = res.data?.mini_program_openid;
  if (miniProgramOpenid) {
    report.setConfig({
      uin: miniProgramOpenid,
    });
  }
  resetLoginCount();
}


Axios.interceptors.request.use(
  (config) => {
    const params = config.params || {};
    Object.assign(config, { params, baseURL: baseUrl });
    return config;
  },
  error => Promise.reject(error),
);
Axios.interceptors.response.use(async (res) => {
  const retcode = +res.data.retcode;
  if (retcode === 0) {
    // 请求正常
    return Promise.resolve(res);
  }
  if (unloginCodeArr.includes(retcode)) {
    console.log(`${res.config.url}：未登录`);
    if (isLoginCountOver(6)) {
      console.log(`${res.config.url}:isLoginCountOver`);
      // 超过3次重定向登录
      showBusinessError();
      throw new CustomException(null, 'loginFail', '登录重定向次数超过6次');
    }
    // 去登录
    console.log(`${res.config.url}:login`);
    await login();
    return Axios(res.config);
  }
  // 非0 or 非登录接口
  // resolve时baseLib底层会返回res.data；而reject是返回的是res，少了data这一层，不符合预期
  // 业务错误需要resolve，让baseLib底层返回res.data。这样业务请求成功和业务请求失败的返回值层级结构才能一致
  // reject适用于http响应失败的情况
  return Promise.resolve(res);
}, error =>
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  Promise.reject(error));

export default baseRequest;
